import Stats from './StatsGroup'

export default Stats
